import { universalViewerSetting } from "../../Environment/Config";
import { dicomFilesRef } from "../../Functions/Dicom/readDicomDataAsArray";
import { isMobile, isTablet, isBrowser } from "react-device-detect";

export function getPatient(title: string, age: string, sex: string) {
  let showSex = 0;

  try {
    showSex = parseInt(sex);
  } catch {
    showSex = 0;
  }

  return {
    patientId: "",
    patientName: title,
    phoneticName: age,
    sex: showSex,
  };
}

export function getStudyList(dicomFiles: dicomFilesRef[]) {
  // 部署・情報だけの配列
  const studyList: string[] = dicomFiles.map((dicomFile) => dicomFile.studyId);
  //配列の重複を削除する処理 Ver. Array.form
  const uniqueStudyList = Array.from(new Set(studyList));
  const resultStudyList = uniqueStudyList.map((studyId) => {
    return {
      uniqueId: studyId,
      institutionCode: "",
    };
  });
  return resultStudyList;
}

export function getSeriesList(
  dicomFiles: dicomFilesRef[],
  uniqueStudyId: string
) {
  const study = dicomFiles.filter(
    (dicomFile) => dicomFile.studyId === uniqueStudyId
  );

  const seriesList: string[] = study.map((dicomFile) => dicomFile.seriesId);

  const uniqueSeriesList = Array.from(new Set(seriesList));
  const resultSeriesList = uniqueSeriesList.map((seriesId) => {
    return {
      uniqueId: seriesId,
      imageUrl: "",
      imageAuth: "",
    };
  });
  return resultSeriesList;
}

export function getSeriesImageDataSet(
  dicomFiles: dicomFilesRef[],
  uniqueStudyId: string,
  uniqueSeriesId: string
) {
  const study = dicomFiles.filter(
    (dicomFile) => dicomFile.studyId === uniqueStudyId
  );
  const series = study.filter(
    (dicomFile) => dicomFile.seriesId === uniqueSeriesId
  );
  if (!series || series.length === 0) {
    return undefined;
  }
  // return 1st slice
  const img = series[0].file;
  return img;
}

export function getInstanceList(
  dicomFiles: dicomFilesRef[],
  uniqueStudyId: string,
  uniqueSeriesId: string
) {
  const study = dicomFiles.filter(
    (dicomFile) => dicomFile.studyId === uniqueStudyId
  );
  const series = study.filter(
    (dicomFile) => dicomFile.seriesId === uniqueSeriesId
  );

  const instanceList: {
    uniqueId: string;
    imageUrl: string;
    imageAuth: string;
  }[] = [];
  series.forEach((dicomFile) => {
    const instance = {
      uniqueId: dicomFile.name,
      imageUrl: "",
      imageAuth: "",
      instanceNumber: dicomFile.instanceNumber,
    };
    instanceList.push(instance);
  });
  return instanceList;
}

export function getImageDataSet(
  dicomFiles: dicomFilesRef[],
  uniqueStudyId: string,
  uniqueSeriesId: string,
  uniqueInstanceId: string
) {
  const study = dicomFiles.filter(
    (dicomFile) => dicomFile.studyId === uniqueStudyId
  );
  const series = study.filter(
    (dicomFile) => dicomFile.seriesId === uniqueSeriesId
  );
  const instance = series.filter(
    (dicomFile) => dicomFile.name === uniqueInstanceId
  );

  let instanceBuffer: ArrayBuffer = new ArrayBuffer(0);

  try {
    instanceBuffer = instance[0].file;
  } catch (e) {
    console.log(e);
  }

  return instanceBuffer;
}

export function openViewer(
  dicomDatasets: dicomFilesRef[],
  title: string,
  age: string,
  sex: string,
  disableOutput: boolean = true
) {
  let url = "https://mnes-universal-viewer-prd.web.app";
  const uniqueStudyId = dicomDatasets[0].studyId;
  const uniqueSeriesId = dicomDatasets[0].seriesId;
  //const device = 'pc';
  if (isBrowser) {
    url += "/pc/viewer?";
  } else if (isTablet) {
    url += "/tablet/viewer?";
  } else if (isMobile) {
    if (uniqueSeriesId) {
      url += "/smartphone/viewer?";
    } else {
      url += "/smartphone/series?";
    }
  } else {
    url += "/viewer?";
  }

  const params = [];
  params.push("uniqueStudyId=" + uniqueStudyId);
  params.push("userConfig=" + 1);
  url += params.join("&");

  window.addEventListener(
    "message",
    async (event) => {
      const message = event.data;
      switch (message.name) {
        case "universalGetUserConfig":
          message.response = JSON.stringify(universalViewerSetting);
          break;
        case "universalGetPermission":
          message.response = {
            viewer3d: "true",
            reconstruction: "true",
            disabledicomtag: "true",
            disableoutput: disableOutput ? "true" : "false",
          };
          break;
        case "universalGetPatient":
          message.response = getPatient(title, age, sex);
          break;
        case "universalGetStudyList":
          message.response = getStudyList(dicomDatasets);
          break;
        case "universalGetSeriesList":
          message.response = getSeriesList(
            dicomDatasets,
            message.request.uniqueStudyId
          );
          break;
        case "universalGetSeriesImageDataSet":
          message.response = getSeriesImageDataSet(
            dicomDatasets,
            message.request.uniqueStudyId,
            message.request.uniqueSeriesId
          );
          break;
        case "universalGetInstanceList":
          message.response = getInstanceList(
            dicomDatasets,
            message.request.uniqueStudyId,
            message.request.uniqueSeriesId
          );
          break;
        case "universalGetImageDataSet":
          message.response = getImageDataSet(
            dicomDatasets,
            message.request.uniqueStudyId,
            message.request.uniqueSeriesId,
            message.request.uniqueInstanceId
          );
          break;
      }

      if (message.requireResponse && viewerWindow) {
        viewerWindow.postMessage(message, "*");
      }
    },
    false
  );

  const viewerWindow = window.open(
    url,
    "universal viewer",
    "toolbar=0,location=0,menubar=0,fullscreen=yes"
  );
}
